import { API_TYPE, fetchData } from '@umu/umu-fetch';

const API = {
    GET_PDF_URL: {
        url: '/napi/pdfjs/config',
        type: API_TYPE.GET,
    },
    GET_PDF_RENDER_VERSION: {
        url: '/napi/pdfjs/render-version',
        type: API_TYPE.GET,
    },
};

export interface IInput {
    elementId?: string;
    isIos?: boolean;
}

export interface IOutput {
    pdfJsUrl: string;
    pdfJsWorkerUrl: string;
    cMapUrl: string;
    wasmMapUrl?: string;
    iccUrlMapUrl?: string;
    standardFontDataUrl?: string;
    /** iOS CJK PUA 修复总开关；false 时不进入修复逻辑 */
    iosCjk?: boolean;
    /** iOS 版本阈值；低于该版本的 iOS 需要进入修复逻辑 */
    iosCjkVersion?: string;
}

export const getPdfUrlApi = (data: IInput): Promise<IOutput> => {
    const { elementId = '', isIos = false } = data;
    const formatData: {
        elementId?: string;
        isIos: number;
    } = {
        isIos: isIos ? 1 : 0,
    };
    if (elementId) {
        formatData['elementId'] = elementId;
    }
    return fetchData(API.GET_PDF_URL, formatData)
        .then((res: IResponse<IOutput>) => res.data)
        .catch((e: any) => {
            console.error('getPdfUrlApi', e);
            throw e;
        });
};

export const getPdfRenderVersion = (params?: {
    id: string;
    type: string;
}): Promise<{
    version: string;
}> => {
    return fetchData(API.GET_PDF_RENDER_VERSION, params || {}, {
        silent: true,
    }).then(
        (res: IResponse<{ version: string }>) => res.data,
        () => {
            return {
                version: '1',
            };
        },
    );
};
